<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header">Historique des professions</div>
        <div class="modal-body">
            <div class="tableHisto" *ngIf="listProfession">
                <frg-table [keysBody]="listProfession" [keysColumn]="professionColumnTable"
                    tableButton1="assets/icons/trash.svg" (onClick1)="deleteProfession($event)"
                    tableButtonNewItem="assets/icons-white/add.svg" [isEdit]="isEdit"
                    (formSubmit)="changeProfessions($event)" (formCancel)="closeHistoProfessionModal(false)"
                    [deleteDuringEdit]="isEdit" *ngIf="isEdit"></frg-table>
                <frg-table [keysBody]="listProfession" [keysColumn]="professionColumnTable" *ngIf="!isEdit"></frg-table>
            </div>
            <div class="button-wrapper" *ngIf="!isEdit">
                <frg-button (activated)="closeHistoProfessionModal(false)" [backgroundColor]="'var(--darkest-primary)'"
                    [type]="'reset'">Fermer</frg-button>
            </div>
        </div>
    </div>
</div>
<div class="modal-background"></div>